import { render, staticRenderFns } from "./BubbleCorner.vue?vue&type=template&id=0cdbff9e&scoped=true&"
import script from "./BubbleCorner.vue?vue&type=script&lang=js&"
export * from "./BubbleCorner.vue?vue&type=script&lang=js&"
import style0 from "./BubbleCorner.vue?vue&type=style&index=0&id=0cdbff9e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdbff9e",
  null
  
)

export default component.exports